"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.updateGlobalConstants = void 0;
var constants_1 = __importDefault(require("@src/constants"));
var utils_1 = require("./utils");
/**
 * Creates, Updates and Deactivates Global Constants/Bot Variables
 * @param domainId id of the domain/bot
 * @param data global constant's/bot variable`s data
 * @param createNew determines whether new const is being created
 */
// eslint-disable-next-line import/prefer-default-export
exports.updateGlobalConstants = function (domainId, data, createNew) {
    var url = constants_1["default"].ENDPOINTS.GLOBAL_CONSTANTS.POST_PUT.replace(':domainId', "" + domainId);
    return utils_1.mogamboRequestV3(url, createNew ? 'POST' : 'PUT', data);
};
